import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { buildPaymentDetailModalBlockParts } from '@common/components/modals/payment-detail/payment-detail-payload.state';
import { ChargeableLounge, FirstBaggage, MealInformation } from '@common/interfaces/mybooking/mybooking.interface';
import { SeatReservationStatus } from '@common/interfaces/servicing-seatmap/seat-reservation-status';
import { ServicingCommonStoreService } from '@common/services';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'asw-service-request-payment-input-payment-amount',
  templateUrl: './service-request-payment-input-payment-amount.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceRequestPaymentInputPaymentAmountComponent extends SupportComponent {
  subscriptions: Subscription = new Subscription();

  id = this.constructor.name;

  chargeableLounge!: ChargeableLounge;
  firstBaggage!: FirstBaggage;
  meal!: MealInformation;
  seatReservationStatus!: SeatReservationStatus;

  constructor(
    public change: ChangeDetectorRef,
    private readonly _modalService: ModalService,
    private readonly _serviceRequestPaymentInputService: ServiceRequestPaymentInputService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    _common: CommonLibService
  ) {
    super(_common);
  }

  init(): void {
    this.subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this.chargeableLounge = servicingCommon.chargeableLounge ?? ({} as ChargeableLounge);
        this.firstBaggage = servicingCommon.firstBaggage ?? ({} as FirstBaggage);
        this.meal = servicingCommon.meal ?? ({} as MealInformation);
        this.seatReservationStatus = servicingCommon.seatReservationStatus ?? ({} as SeatReservationStatus);
        let totalPrice: number = 0;
        totalPrice += servicingCommon.seatReservationStatus?.totalAmount ?? 0;
        totalPrice += servicingCommon.chargeableLounge?.totalAmount ?? 0;
        totalPrice += servicingCommon.firstBaggage?.totalAmount ?? 0;
        totalPrice += servicingCommon.meal?.totalAmount ?? 0;
        this._serviceRequestPaymentInputService.totalPrice = totalPrice;
        this.change.markForCheck();
      })
    );
  }

  // [2] 支払総額
  get totalPrice() {
    return this._serviceRequestPaymentInputService.totalPrice;
  }

  // (16)	詳細ボタン押下処理 ※支払詳細モーダル
  clickPaymentDetails() {
    // (16.1)	支払情報詳細モーダルを表示する。
    const part = buildPaymentDetailModalBlockParts();
    this._modalService.showSubModal(part);
  }

  reload(): void {
    /* override abstract reload function of base class */
  }

  destroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
